import React from 'react';
import '../src/styles/Global.css'
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AlertProvider } from './context/AlertContext'; // adjust path if needed

import SEO from './seo/SEO';
import EstimatingOverview from './pages/estimating/EstimatingOverview';
import { pages, normalizePath } from './seo/pages';


import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Login from './features/auth/Login';
import Registration from './features/auth/Registration';
import Home from './pages/home/Home'; // Importing the page components
import About from './pages/about/About';
import Footer from './components/Footer';
import NotFound from './components/Notfound';
import GnContractor from './pages/services/gernal_contractor/GnContractor';
import Contact from './pages/contact/Contact';
import Flooring from './pages/services/sub_contractor/Flooring'
import Drywall from './pages/services/sub_contractor/Drywall'
import Painting from './pages/services/sub_contractor/Painting'
import Siding from './pages/services/sub_contractor/Siding';
import Lumber from './pages/services/sub_contractor/Lumber';
import Concrete from './pages/services/sub_contractor/Concrete';
import Masonry from './pages/services/sub_contractor/Masonry';
import Roofing from './pages/services/sub_contractor/Roofing';
import Insulation from './pages/services/sub_contractor/Insulation';
import Demolition from './pages/services/sub_contractor/Demolition';
import Electrical from './pages/services/sub_contractor/Electrical';
import Mep from './pages/services/sub_contractor/Mep';
import Opening from './pages/services/sub_contractor/Opening';
import Policies from './pages/policies/Policies';
import Faq from './pages/frequently-asked-questions/FrequentlyAskedQuestions';
import Blog from './pages/blog/Blog';
import ScheduleMeeting from './pages/schedule/ScheduleMeeting';


import './App.css';
import ApproveUser from './features/auth/ApproveUser';
// Shared by BrowserRouter and build-time StaticRouter.
export function SiteRoutes() {
  const location = useLocation();
  const path = normalizePath(location.pathname);
  if (pages[path] && path !== location.pathname) {
    return <Navigate replace to={path + location.search + location.hash} />;
  }
  return (
    <AlertProvider>
      <SEO path={path} />
      <ScrollToTop />
      <Navbar />
      <main id="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/policy" element={<Policies />} />
          <Route path="/frequently-asked-questions" element={<Faq />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/schedule-meeting" element={<ScheduleMeeting />} />
          <Route path="/login" element={<Login />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/material-takeoff-services" element={<EstimatingOverview />} />
          <Route path="/general-contractor" element={<GnContractor />} />
          <Route path="/services/flooring-estimation" element={<Flooring />} />
          <Route path="/services/drywall-estimation" element={<Drywall />} />
          <Route path="/services/painting-estimation" element={<Painting />} />
          <Route path="/services/siding-estimation" element={<Siding />} />
          <Route path="/services/lumber-estimation" element={<Lumber />} />
          <Route path="/services/concrete-estimation" element={<Concrete />} />
          <Route path="/services/masonry-estimation" element={<Masonry />} />
          <Route path="/services/roofing-estimation" element={<Roofing />} />
          <Route path="/services/insulation-and-moisture-protection" element={<Insulation />} />
          <Route path="/services/demolition-estimation" element={<Demolition />} />
          <Route path="/services/electrical-estimation" element={<Electrical />} />
          <Route path="/services/mep-estimation" element={<Mep />} />
          <Route path="/services/openings-and-hardware" element={<Opening />} />
          <Route path="/approve-user" element={<ApproveUser />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </AlertProvider>
  );
}
export default function App() {
  return <Router><SiteRoutes /></Router>;
}
